import { gql, useQuery } from "@apollo/client";
import { EffectiveFeatureFlags } from "./schema/EffectiveFeatureFlags";

export const effectiveFeatureFlagsQuery = gql`
  query EffectiveFeatureFlags {
    features {
      effective {
        flags {
          key
          enabled
        }
        maxAgeSeconds
        degraded
      }
    }
  }
`;

/**
 * Reads the tenant's licensed capabilities.
 *
 * network-only rather than cache-first: an entitlement change must reach an open session without a
 * sign-out, so this must not be served indefinitely from the Apollo cache. Refresh cadence is
 * governed by maxAgeSeconds, which the server publishes.
 */
export const useEffectiveFeatureFlags = () =>
  useQuery<EffectiveFeatureFlags>(effectiveFeatureFlagsQuery, {
    fetchPolicy: "network-only",
    errorPolicy: "all"
  });
